export const JUSZAP_PLANS = {
  padrao: {
    // Valor enviado ao backend no checkout (mesma nomenclatura da LP).
    apiPlan: "STANDARD",
    planType: "Plano Padrão",
    name: "Padrão",
    price: 49.90,
    features: [
      "Organização automática das conversas",
      "IA treinada para atendimentos jurídicos",
      "Triagem e qualificação de leads 24hrs por dia",
    ],
  },
  personalizado: {
    apiPlan: "CUSTOM",
    planType: "Plano Personalizado",
    name: "Personalizado",
    price: 99.90,
    highlight: "Mais completo",
    features: [
      "Tudo do Plano Padrão",
      "Fluxos de atendimento personalizados com IA",
      "IA treinada com as informações do seu escritório",
    ],
  },
};

export const PLAN_KEYS = ["padrao", "personalizado"];

export const resolvePlanKey = (plan, price) => {
  const normalized = String(plan || "").toLowerCase();
  if (normalized.includes("personaliz") || normalized.includes("custom")) {
    return "personalizado";
  }
  if (
    normalized.includes("padr") ||
    normalized.includes("standard") ||
    normalized.includes("basic")
  ) {
    return "padrao";
  }
  if (Number(price) >= 99) return "personalizado";
  return "padrao";
};
